var SCM = SCM || {};

(function (bcmv, $, iou) {

    // new class created for future functionality
    // initialize functionality
    bcmv.init = function () {
        iou.init();
    };
})(SCM.BookChapterMainView = SCM.BookChapterMainView || {}, jQuery, SCM.InstitutionOpenUrl);
